import { useV2GetPsaDefaultCompanyQuery } from "@generated";
import { Opt } from "../../types/PsaProject";

// Resolves the company the push should open with: the ScopeStack client on the
// project, mapped to its PSA-side external id. The server returns an empty
// `data` object when that client carries no mapping for this connection, which
// is a legitimate "no default" — not an error — so it maps to null.
export const usePsaDefaultCompany = (
  integrationId: string,
  projectId: string,
  opts?: { skip?: boolean }
) => {
  const { data, isFetching } = useV2GetPsaDefaultCompanyQuery(
    { id: integrationId, projectId },
    { skip: !!opts?.skip || !integrationId || !projectId }
  );
  const row = data?.data;
  const company: Opt | null = row?.id
    ? { value: String(row.id), label: row.name ?? String(row.id) }
    : null;
  return { company, isFetching };
};
